<template>
	<Col>
		<Row>
			<u><h3 @click="changeTemplate" class="template-btn mr-2 cursor-pointer">Change template</h3></u>
			<u><h3 @click="editTemplate" class="template-btn cursor-pointer">Edit template</h3></u>
		</Row>
		<template v-if="dynamicParams.length">
			<b><h3 class="mt-4">Dynamic content</h3></b>
			<h5 class="med">Map data into the dynamic fields</h5>
			<StringParamType
				v-for="(param, i) in dynamicParams"
				:param="param"
				:key="param.key + '_' + i"
				:readonly="false"
				v-bind="componentProps"
				forceTemplateValue
				:templateValue="localValue.params[param.key]"
				@update-input-field="updateInputField"
			/>
		</template>
	</Col>
</template>

<script>
import ParamTypeMixin from './mixins/ParamTypeMixin';
import StringParamType from '@/components/BlockEditor/BlockEditorParams/ParamTypes/StringParamType.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { setIsSideBarDrawerOpen, setIsShowKnob } from '@/store/modules/sideBarDrawer/actions';
import { setSelectedEmailTemplateId } from '@/store/modules/transactionalEmailTemplate/actions';
import { selectedEmailTemplate, selectedEmailTemplateId, useEmailTemplate } from '@/store/modules/transactionalEmailTemplate/getters';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';

const getDynamicParamKeysFromTemplateText = (templateText) => {
	const regexPattern = /\{\{(.+?)\}\}/g;
	const matches = templateText.match(regexPattern) || [];
	return matches.map((match) => match.replace(/{{|}}/g, '').trim());
};

export default {
	name: 'EmailTemplateParamType',
	mixins: [ParamTypeMixin],
	components: { StringParamType },
	beforeDestroy() {
		this.setIsShowKnob(false);
		this.setSelectedEmailTemplateId(null); // This way mounted triggers `selectedTemplate` watch when creating a new action
	},
	mounted() {
		this.setSelectedEmailTemplateId(this.localValue?.template_id || 1); // TODO, || this.defaultTemplateId
		this.setIsShowKnob(true);
		this.setIsSideBarDrawerOpen(true);
	},
	methods: {
		...mapActionsShorthand({ setIsShowKnob, setIsSideBarDrawerOpen, setSelectedEmailTemplateId }),
		updateInputField(newValue) {
			const paramVal = newValue.map.value;
			this.localValue = { ...this.localValue, params: { ...this.localValue.params, [newValue.map.key]: paramVal } };
		},
		setDynamicParams(params) {
			this.dynamicParams = Object.keys(params).map((key) => ({
				key,
				name: key,
				type: 'string',
				required: false,
			}));
		},
		async changeTemplate() {
			const dialogRes = await AppDialogManagerService.openChangeEmailTemplateDialog();
			if (dialogRes?.id) {
				this.setSelectedEmailTemplateId(dialogRes.id);
			}
		},
		editTemplate() {
			alert('edit template'); // TODO
		},
	},
	computed: {
		...mapGettersShorthand({ selectedEmailTemplate, selectedEmailTemplateId, useEmailTemplate }),
		componentProps() {
			return {
				...this.$attrs,
				node: this.node,
				action: this.action,
				service: this.service,
				acceptSingleValue: true,
				isFocused: this.isFocused,
				showDataMenu: this.showDataMenu,
			};
		},
		selectedTemplate() {
			return this.selectedEmailTemplateId;
		},
	},
	data() {
		return {
			dynamicParams: [],
		};
	},
	watch: {
		localValue: {
			handler(newV, oldV) {
				if (newV?.params && (newV?.template_id !== oldV?.template_id || this.dynamicParams.length === 0)) {
					this.setDynamicParams(newV.params);
				}
			},
			deep: true,
		},
		selectedTemplate: {
			handler(newV) {
				const template = this.useEmailTemplate(newV);
				const { text, id } = template;
				const emailTemplateDynamicParamKeys = getDynamicParamKeysFromTemplateText(text);
				const params = Object.fromEntries(emailTemplateDynamicParamKeys.map((key) => [key, this.localValue?.params?.[key] || '']));
				this.localValue = { template_id: id, params };
			},
			deep: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.tab-button {
	border-radius: 6px;
	height: 26px !important;
	font-size: 12px !important;
	padding: 0px 8px !important;
	border: 1px solid #e7eaf3;
	background: #f9fafc !important;
	&.selected {
		margin-left: -3px;
		color: var(--bold-border-color);
		background: var(--bg-color) !important;
		box-shadow: 0px 3px 6px var(--shadow-color) !important;
	}
}

.template-btn {
	color: #6a6be9;
}
</style>
